import { format } from 'date-fns'

import { t } from '@/i18n'

import { formatCurrency } from '../fomatter.utils'
import { BODY_FONT } from '../text.utils'
import type { TicketElement } from '../TicketElement'
import type { Movement } from '../types'

export class MovementsBreakdown implements TicketElement {
  movements: Movement[]
  lineHeight: number
  separatorPadding: number
  topPadding: number
  totalEndAmount: number

  constructor(movements: Movement[]) {
    this.movements = movements
    this.lineHeight = 22
    this.separatorPadding = 20
    this.topPadding = 30
    this.totalEndAmount = movements.reduce((total, movement) => {
      total += movement.diff
      return total
    }, 0)
  }

  height(): number {
    return (
      this.lineHeight * this.movements.length +
      this.lineHeight +
      this.separatorPadding +
      this.topPadding
    )
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    ctx.font = `bold 12px ${BODY_FONT}`
    ctx.fillStyle = 'black'
    ctx.textAlign = 'right'
    ctx.fillText(t('movements-report.balance'), width, top)
    this.movements.forEach((movement: Movement) => {
      ctx.textAlign = 'right'
      const inOrOut =
        movement.diff < 0 ? t('movements-report.pay-out') : t('movements-report.pay-in')
      top += this.lineHeight

      ctx.font = `12px ${BODY_FONT}`
      ctx.fillText(formatCurrency(movement.diff), width, top)
      ctx.fillText(format(new Date(movement.creationTime), 'HH:mm'), width * 0.5, top)
      ctx.textAlign = 'left'
      ctx.font = `bold 12px ${BODY_FONT}`
      ctx.fillText(movement.tableName || movement.tabCode || inOrOut, 0, top)
    })
    ctx.fillStyle = 'black'
    ctx.font = `bold 12px ${BODY_FONT}`
    top += this.separatorPadding
    ctx.fillRect(0, top, width, 1)
    top += this.lineHeight
    ctx.fillText(t('report.total') + ':', 0, top)
    ctx.textAlign = 'right'
    ctx.fillText(formatCurrency(this.totalEndAmount), width, top)
  }
}
